import { useState } from 'react';
import { Outlet } from 'react-router';
import styled from 'styled-components';
import Router from '../Router';

const Layout = styled.main`
  position: relative;
`;

function App() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <Layout>
      {/* <TopBar openMenu={() => setMenuOpen(true)} />
      <Navigation isOpen={menuOpen} onClose={() => setMenuOpen(false)} /> */}
      <Router />
    </Layout>
  );
}

export default App;
